import React, { useEffect, useState } from 'react';
import { heroContent } from '../../config/v1/content/hero.content';
import './V1HeroSection.css';

interface V1HeroSectionProps {
  theme: 'premium' | 'energetic';
  onCTAClick: () => void;
}

const V1HeroSection: React.FC<V1HeroSectionProps> = ({ theme, onCTAClick }) => {
  const content = heroContent[theme];
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className={`v1-hero ${isVisible ? 'visible' : ''}`}>
      <div className="v1-hero-background">
        <div className="v1-hero-overlay"></div>
      </div>

      <div className="v1-container v1-hero-content">
        <div className="v1-hero-text">
          <span className="v1-hero-eyebrow v1-animate-in" style={{ animationDelay: '0.2s' }}>
            {content.eyebrow}
          </span>

          <h1 className="v1-hero-headline v1-animate-in" style={{ animationDelay: '0.4s' }}>
            {content.headline}
          </h1>

          <p className="v1-hero-subheadline v1-animate-in" style={{ animationDelay: '0.6s' }}>
            {content.subheadline}
          </p>

          <div className="v1-hero-trust-signals v1-animate-in" style={{ animationDelay: '0.8s' }}>
            {content.trustSignals.map((signal, index) => (
              <div key={index} className="v1-trust-signal">
                <span className="v1-trust-icon">✓</span>
                <span>{signal}</span>
              </div>
            ))}
          </div>

          <div className="v1-hero-cta-wrapper v1-animate-in" style={{ animationDelay: '1s' }}>
            <button className="v1-btn-primary v1-hero-cta" onClick={onCTAClick}>
              {content.cta}
            </button>

            <div className="v1-hero-social-proof">
              <div className="v1-avatar-stack">
                <div className="v1-avatar"></div>
                <div className="v1-avatar"></div>
                <div className="v1-avatar"></div>
                <div className="v1-avatar-count">+44</div>
              </div>
              <span className="v1-social-proof-text">{content.socialProof}</span>
            </div>
          </div>
        </div>

        <div className="v1-hero-visual v1-animate-in" style={{ animationDelay: '0.6s' }}>
          <div className="v1-hero-card v1-glass">
            <div className="v1-hero-card-icon">📊</div>
            <div className="v1-hero-card-content">
              <h3>Gwarantowane wyniki</h3>
              <p>98% naszych uczniów przekracza swoje oczekiwania</p>
            </div>
          </div>

          <div className="v1-hero-card v1-glass" style={{ animationDelay: '0.8s' }}>
            <div className="v1-hero-card-icon">⚡</div>
            <div className="v1-hero-card-content">
              <h3>Szybkie efekty</h3>
              <p>Pierwsze rezultaty już po 2 tygodniach</p>
            </div>
          </div>

          <div className="v1-hero-card v1-glass" style={{ animationDelay: '1s' }}>
            <div className="v1-hero-card-icon">🎯</div>
            <div className="v1-hero-card-content">
              <h3>Indywidualne podejście</h3>
              <p>Plan dostosowany do Twoich potrzeb</p>
            </div>
          </div>
        </div>
      </div>

      <div className="v1-hero-scroll-indicator">
        <span>Scroll</span>
        <div className="v1-scroll-arrow">↓</div>
      </div>
    </section>
  );
};

export default V1HeroSection;
